import $ from 'jquery';

let navigation = () => {
  const $menu = $('.site-menu');
  if (!$menu.length) return;

  const setMenuState = (isOpen) => {
    $menu
      .toggleClass('is-open', isOpen)
      .attr('aria-hidden', isOpen ? 'false' : 'true');

    $('body').toggleClass('body-lock', isOpen);
    $('.site-header .menu-trigger').attr('aria-expanded', isOpen ? 'true' : 'false');
  };

  $(document)
    .off('click.navigation', '.menu-trigger')
    .on('click.navigation', '.menu-trigger', function (e) {
      e.preventDefault();

      setMenuState(!$menu.hasClass('is-open'));
    });

  $(document)
    .off('click.navigationBackdrop', '.site-menu')
    .on('click.navigationBackdrop', '.site-menu', function (e) {
      if (e.target === this) {
        setMenuState(false);
      }
    });

  $(document)
    .off('keydown.navigation')
    .on('keydown.navigation', function (e) {
      if (e.key === 'Escape' && $menu.hasClass('is-open')) {
        setMenuState(false);
      }
    });

  $(document)
    .off('click.navigationLink', '.site-menu a')
    .on('click.navigationLink', '.site-menu a', function () {
      const href = (this.getAttribute('href') || '').trim();
      if (href === '' || href === '#') {
        return;
      }

      setMenuState(false);
    });
};

export default navigation;
